import { Option, type Result, type Schema as S } from "effect";
import * as AsyncData from "foldkit/asyncData";

import { ApiError } from "./errors";

/** Model field Schema for server data: `AsyncData<T, ApiError>`. */
export const apiData = <A, AI>(data: S.Codec<A, AI>) =>
	AsyncData.Schema(data, ApiError);

/** Issue-time transition: Success/Stale → Refreshing, Idle/Failure → Loading, in-flight unchanged. */
export const start = <A, E>(
	self: AsyncData.AsyncData<A, E>,
): AsyncData.AsyncData<A, E> =>
	Option.getOrElse(AsyncData.revalidateOrLoad(self), () => self);

/** Result-time transition: success → Success, failure → Stale (keeps data) or Failure. */
export const settle = <A, E>(
	self: AsyncData.AsyncData<A, E>,
	result: Result.Result<A, E>,
): AsyncData.AsyncData<A, E> => AsyncData.settle(self, result);
